import React, { useState } from 'react';
import { View, ScrollView } from 'react-native';
import IonIcon from 'react-native-vector-icons/Ionicons';

import { useDispatch, useSelector } from 'react-redux';
import { AppHeader } from '../../../components/common';
import { AppSlider, AppText, AppSelector } from '../../../components/form';
import { GreenButton } from '../../../components/derivative';
import { pixelDimensions } from '../../../config/utils';
import styles from './styles';
import { WorkerActions } from '../../../redux/reducers/workerReducer';

const LevelThree = ({ navigation }) => {
  const dispatch = useDispatch();
  const { pnfamData } = useSelector((state) => state.worker);

  const [sliders, changeSliderValue] = useState({
    Estresse: 0,
    Ansiedade: 0,
    'Qualidade do Sono': 0,
  });
  const [levelThreeParams, updateL2Params] = useState({
    pain: undefined,
  });
  const handleSliderChange = (title, value) => {
    changeSliderValue({
      ...sliders,
      [title]: value,
    });
  };
  const optionsYesNo = [
    { label: 'SIM', value: 1 },
    { label: 'NÃO', value: 0 },
  ];

  const nextPage = () => {
    const data = {
      ...pnfamData,
      estresse: sliders.Estresse,
      ansiedade: sliders.Ansiedade,
      qualidade_sono: sliders['Qualidade do Sono'],
      dor_cabeca: levelThreeParams.pain,
    };
    dispatch({ type: WorkerActions.UPDATE_DATA, dataType: 'pnfamData', dataValue: { ...data } });
    navigation.navigate('Worker Level Four');
  };
  return (
    <View style={styles.viewBase}>
      <AppHeader title="Esgotamento" hasBack navigation={navigation} />
      <View style={styles.content}>
        <ScrollView style={styles.scroll}>
          <View style={{ paddingHorizontal: pixelDimensions(10) }}>
            <AppText
              size="bold"
              style={styles.textClassify}
            >
              {'CLASSIFIQUE SEU NÍVEL DE\nESGOTAMENTO MENTAL'}
            </AppText>
            <AppSlider
              sliderContainerStyles={{ alignSelf: 'center' }}
              sliderSubContainerStyles={{ width: pixelDimensions(80) }}
              title="Estresse"
              value={`${sliders.Estresse} %`}
              changeValue={handleSliderChange}
              showHelper
              textHelper="Mensagem de ajuda!"
            />
            <AppSlider
              sliderContainerStyles={{ alignSelf: 'center' }}
              sliderSubContainerStyles={{ width: pixelDimensions(80) }}
              title="Ansiedade"
              value={`${sliders.Ansiedade} %`}
              changeValue={handleSliderChange}
              showHelper
              textHelper="Mensagem de ajuda!"
            />
            <View style={{ width: pixelDimensions(80) }}>
              <AppSlider
                sliderContainerStyles={{
                  marginTop: pixelDimensions(5),
                  marginBottom: -pixelDimensions(5),
                  alignSelf: 'center',
                }}
                sliderSubContainerStyles={{ width: pixelDimensions(80) }}
                max={2}
                step={1}
                title="Qualidade do Sono"
                showValue={false}
                value={sliders['Qualidade do Sono']}
                changeValue={handleSliderChange}
              />
              <View
                style={{
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  zIndex: -1,
                }}
              >
                <AppText size="bold" style={styles.textClassify}>
                  Baixa
                </AppText>
                <AppText size="bold" style={styles.textClassify}>
                  Média
                </AppText>
                <AppText size="bold" style={styles.textClassify}>
                  Alta
                </AppText>
              </View>
            </View>
            <View style={{ marginTop: pixelDimensions(5) }}>
              <AppText
                size="bold"
                style={styles.textClassify}
              >
                {'TEM DORES DE CABEÇA\nCOM FREQUÊNCIA'}
              </AppText>
              <AppSelector
                options={optionsYesNo}
                optionValue="value"
                optionText="label"
                target="pain"
                changeData={(target, value) => updateL2Params({ ...levelThreeParams, [target]: value })}
                fieldValue={levelThreeParams.pain}
              />
            </View>
            <GreenButton
              onPress={() => nextPage()}
              label={(
                <AppText size="bold" style={styles.textButtonGreen}>
                  AVANÇAR
                  {' '}
                  <IonIcon
                    style={{ fontSize: pixelDimensions(5) }}
                    name="chevron-forward"
                  />
                </AppText>
              )}
            />
          </View>
        </ScrollView>
      </View>
    </View>
  );
};

export default LevelThree;
